var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"mb__popup-action CartListBtn",attrs:{"status":_vm.isCartOpen ? 'open' : ''},on:{"click":_vm.handleClickCartIcon}},[_c('span',{staticClass:"Quantity"},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }